import React from 'react';
import { EditIcon, TrashIcon, CheckIcon, GlobeIcon } from 'lucide-react';
export function CurrencyList({
  currencies,
  onSelectCurrency,
  onDeleteCurrency,
  locale
}) {
  return <div className="bg-white shadow overflow-hidden sm:rounded-lg" data-id="element-14885">
      {currencies.length === 0 ? <div className="px-4 py-5 sm:p-6 text-center text-gray-500" data-id="element-14886">
          No currencies found. Add a new currency to get started.
        </div> : <table className="min-w-full divide-y divide-gray-200" data-id="element-14887">
          <thead className="bg-gray-50" data-id="element-14888">
            <tr data-id="element-14889">
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-14890">
                Code
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-14891">
                Name
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-14892">
                Symbol
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-14893">
                Countries
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-14894">
                Status
              </th>
              <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-14895">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200" data-id="element-14896">
            {currencies.map(currency => <tr key={currency.currencyId} className="hover:bg-gray-50" data-id="element-14897">
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-14898">
                  <div className="flex items-center" data-id="element-14899">
                    <div className="text-sm font-medium text-indigo-600" data-id="element-14900">
                      {currency.code}
                    </div>
                    <span className="ml-2 px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-gray-100 text-gray-800" data-id="element-14901">
                      {currency.numericCode}
                    </span>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-14902">
                  <div className="text-sm text-gray-900" data-id="element-14903">{currency.name}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-14904">
                  <div className="text-sm text-gray-900" data-id="element-14905">{currency.symbol}</div>
                </td>
                <td className="px-6 py-4" data-id="element-14906">
                  <div className="text-sm text-gray-900 flex items-center" data-id="element-14907">
                    <GlobeIcon className="h-4 w-4 mr-1 text-gray-400" data-id="element-14908" />
                    <span data-id="element-14909">
                      {currency.countries.length > 2 ? `${currency.countries[0]}, ${currency.countries[1]} +${currency.countries.length - 2} more` : currency.countries.join(', ')}
                    </span>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-14910">
                  {currency.isDefault ? <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800" data-id="element-14911">
                      <CheckIcon className="h-4 w-4 mr-1" data-id="element-14912" />
                      Default
                    </span> : <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-gray-100 text-gray-800" data-id="element-14913">
                      Active
                    </span>}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-14914">
                  <button onClick={() => onSelectCurrency(currency)} className="text-indigo-600 hover:text-indigo-900 mr-4" data-id="element-14915">
                    <EditIcon className="h-4 w-4" data-id="element-14916" />
                    <span className="sr-only" data-id="element-14917">Edit</span>
                  </button>
                  <button onClick={e => {
              e.stopPropagation();
              onDeleteCurrency(currency);
            }} className="text-red-600 hover:text-red-900" disabled={currency.isDefault} data-id="element-14918">
                    <TrashIcon className="h-4 w-4" data-id="element-14919" />
                    <span className="sr-only" data-id="element-14920">Delete</span>
                  </button>
                </td>
              </tr>)}
          </tbody>
        </table>}
    </div>;
}